import { render, staticRenderFns } from "./ChooseExtractProfessionalTitle.vue?vue&type=template&id=16801fc4&scoped=true"
import script from "./ChooseExtractProfessionalTitle.vue?vue&type=script&lang=js"
export * from "./ChooseExtractProfessionalTitle.vue?vue&type=script&lang=js"
import style0 from "./ChooseExtractProfessionalTitle.vue?vue&type=style&index=0&id=16801fc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16801fc4",
  null
  
)

export default component.exports